// Whether `key` is `obj`'s own property, so a server-supplied key such as
// "constructor" never reads Object.prototype's member. Object.hasOwn would
// say the same, but the desktop app supports macOS 12.0, whose WKWebView
// (Safari 15.0 to 15.3) does not have it (it came in Safari 15.4), and the
// build does not polyfill built-ins.
export function hasOwn(obj: object, key: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
